import { heroStats, quickTags } from '@/mocks/homeData';
import type { HeroStat } from '@/pages/home/types';

const stats = heroStats as HeroStat[];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20banner%20of%20glowing%20video%20player%20interface%20panels%20and%20floating%20play%20buttons%20over%20a%20deep%20warm%20crimson%20and%20deep%20green%20gradient%20with%20soft%20cinematic%20bokeh%20and%20light%20streaks%2C%20modern%20editorial%20tech%20aesthetic%2C%20rich%20saturated%20color%20grading&width=1920&height=1080&seq=xg-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 pt-28 pb-14 md:px-8 md:pt-40 md:pb-20">
        <div className="mx-auto w-full max-w-6xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/20 px-4 py-1.5 text-xs text-background-50 md:text-sm">
            <i className="ri-live-line text-primary-300"></i>
            每 30 分钟更新一次的站内热度聚合
          </span>

          <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl lg:text-6xl">
            西瓜视频热门视频排行榜
          </h1>

          <p className="mx-auto mt-5 max-w-3xl text-sm leading-relaxed text-background-100 md:text-base">
            这里聚合西瓜视频当前高热度的视频内容与榜单数据，覆盖站内爆款、口碑节目与编辑精选。
            无论你是想追最新热点，还是想安静补几部经典，都能在这一页快速定位，省下反复刷找的时间。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#ranking"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-fire-line"></i>
              立即查看热门榜单
            </a>
            <a
              href="#guide"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-50/40 px-6 py-3 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-white/10 sm:w-auto"
            >
              <i className="ri-compass-3-line"></i>
              怎么高效追热门
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
            {quickTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-background-50/25 bg-black/20 px-3 py-1 text-xs text-background-100 md:text-sm"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 pb-14 md:px-8 md:pb-20">
        <div className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-black/25 px-4 py-5 text-center md:px-6 md:py-6">
              <div className="font-heading text-2xl text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-sm font-normal opacity-80">{stat.unit}</span>
              </div>
              <div className="mt-1 text-xs text-background-100 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}